// extracted by mini-css-extract-plugin
export default {"holder":"NoticeLine_holder__BRw0I","holder__inner":"NoticeLine_holder__inner__dhht5","msg":"NoticeLine_msg__eJnUn","msg__close":"NoticeLine_msg__close__0uSgN"};